import { createSlice } from '@reduxjs/toolkit';

import { fetchActiveContractByCategory, fetchEffectiveUnitPrice } from './actions';
import type { ActiveContractByCategory, ContractCategory, EffectiveUnitPrice } from '../types';

interface CategoryState {
  data: ActiveContractByCategory | null;
  loading: boolean;
  error: string | null;
  requestId: string | null;
  unitPrice: EffectiveUnitPrice | null;
  unitPriceLoading: boolean;
}

type ContractsState = Record<ContractCategory, CategoryState>;

const emptyCategory = (): CategoryState => ({
  data: null,
  loading: false,
  error: null,
  requestId: null,
  unitPrice: null,
  unitPriceLoading: false,
});

const initialState: ContractsState = {
  NOTIFICACAO: emptyCategory(),
  NEGOCIACAO: emptyCategory(),
  ARBITRAGEM: emptyCategory(),
  MEDIACAO: emptyCategory(),
};

const contractsSlice = createSlice({
  name: 'contracts',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchActiveContractByCategory.pending, (state, action) => {
        const category = action.meta.arg;
        state[category].loading = true;
        state[category].error = null;
        state[category].requestId = action.meta.requestId;
      })
      .addCase(fetchActiveContractByCategory.fulfilled, (state, action) => {
        const category = action.meta.arg;
        if (state[category].requestId !== action.meta.requestId) return;
        state[category].data = action.payload;
        state[category].loading = false;
      })
      .addCase(fetchActiveContractByCategory.rejected, (state, action) => {
        const category = action.meta.arg;
        if (state[category].requestId !== action.meta.requestId) return;
        state[category].loading = false;
        state[category].error = action.payload ?? 'Erro desconhecido';
      })
      .addCase(fetchEffectiveUnitPrice.pending, (state, action) => {
        const category = action.meta.arg;
        state[category].unitPriceLoading = true;
      })
      .addCase(fetchEffectiveUnitPrice.fulfilled, (state, action) => {
        const category = action.meta.arg;
        state[category].unitPrice = action.payload;
        state[category].unitPriceLoading = false;
      })
      .addCase(fetchEffectiveUnitPrice.rejected, (state, action) => {
        const category = action.meta.arg;
        state[category].unitPrice = null;
        state[category].unitPriceLoading = false;
      });
  },
});

export const contractsReducer = contractsSlice.reducer;
